export const actionTypes = {
    addApiException: 'ADD_API_EXCEPTION',
    clearApiExceptions : 'CLEAR_API_EXCEPTIONS',
};
